import {
  show_list_default
} from "./chunk-VUTGEAIZ.js";

// src/layouts/show-list/index.ts
var show_list_default2 = show_list_default;

export {
  show_list_default2 as show_list_default
};
